import React from 'react';

const BoostSelfAddNoBills = ({
  close: closeWithOpenFinicity,
}) => {
  return (
    <>
      <div className="flex flex-row mx-auto bg-gray-200 border-gray-500 border-b pl-4 ">
        <h3 className="mt-2 text-xl">{"No eligible bills found"}</h3>
      </div>
      <div style={{ minHeight: "100%" }} className="flex py-2 px-4 flex-col bg-white">
        <p className="py-1">
            We couldn't find any eligible bills that can be added to your TomoBoost account. Bills are payments made from the financial institution you have linked to your TomoBoost account.
        </p>
        <p className="text py-1 ">
          If you made a payment from a different account or financial institution that has not been linked to your TomoBoost account yet, you can add it {" "}
          <button
            type="button"
            onClick={() => { closeWithOpenFinicity(null, null, true); }}
            className="text-boost-primary-purple hover:text-purple-600"
          >
            <u>here.</u>
          </button>
        </p>
      </div>
    </>
  );
};

export default BoostSelfAddNoBills;